/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef} from 'react'
import ApexCharts, {ApexOptions} from 'apexcharts'
import {getCSS, getCSSVariableValue} from '../../../assets/ts/_utils'
import {useThemeMode} from '../../layout/theme-mode/ThemeModeProvider'

type Props = {
  className: string
}

const ChartsDevicesPerOU: React.FC<Props> = ({className}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const {mode} = useThemeMode()
  const today = new Date();
  const monthNames = ['Gulzar', 'Kita Tour', 'Peegi Umroh','Amin Tour', 'Tiga Cahaya', 'Al Amin Tour'];
  const [selectedYear, setSelectedYear] = React.useState(today.getFullYear());
  console.log(selectedYear)
  
  const getOptionYears = () => {
    const years = [];
    for (let i = 0; i < 5; i++) {
      years.push(today.getFullYear() - i);
    }
    return years;
  }
  const optionsYears = getOptionYears();


  const dayFormat = (datetimestr: Date) => {
    const date = new Date(datetimestr);
    const res = new Intl.DateTimeFormat('id', {
      day: 'numeric',
      month: 'short',
    }).format(date);
    return res;
  }


  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }

    const height = parseInt(getCSS(chartRef.current, 'height'))

    const chart = new ApexCharts(chartRef.current, getChartOptions(height))
    if (chart) {
      chart.render()
    }

    return chart
  }

  useEffect(() => {
    const chart = refreshChart()
    return () => {
      if (chart) {
        chart.destroy()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartRef, mode])

function getChartOptions(height: number): ApexOptions {
  const labelColor = getCSSVariableValue('--bs-gray-500')
  const borderColor = getCSSVariableValue('--bs-gray-200')
  const secondaryColor = getCSSVariableValue('--bs-gray-300')

  return {
    series: [
      {
        name: 'Total',
        data: [234, 678, 234, 678, 234,534, 0, 0, 0, 0, 0, 0],
      },
    ],
    chart: {
      fontFamily: 'inherit',
      type: 'bar',
      height: height,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '15',
        borderRadius: 5,
      },
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: monthNames,
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: "#000000",
          fontSize: '10px',
          fontWeight: 600
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: labelColor,
          fontSize: '10px',
        },
        formatter: function (val) {
          return Number.isInteger(val) ? `${val}` : '';
        }
      },
    },
    fill: {
      opacity: 1,
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: '12px',
      },
      y: {
        formatter: function (val) {
          return val + ' '
        },
      },
    },
    colors: ['#3B86F7', secondaryColor],
    grid: {
      borderColor: borderColor,
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
  }
}

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-normal fs-4 mb-1'>Data Perangkat Per OU (Umrah)</span>
        </h3>

        <select
            onChange={(e) => { setSelectedYear(parseInt(e.target.value)) }}
            name='year'
            id='year'
            className='form-select form-select-md bg-gray-200 w-100px border-0 px-4'
        >
            {optionsYears.map((row, idx) => (
            <option key={idx} value={row} style={{padding: '10px' , backgroundColor: 'white'}}>
                {row}
            </option>
            ))}
        </select>
      </div>
      {/* end::Header */}

      {/* begin::Body */}
      <div className='card-body'>
        {/* begin::Chart */}
        <div ref={chartRef} id='kt_charts_widget_2_chart' style={{height: '300px'}}></div>
        {/* end::Chart */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export {ChartsDevicesPerOU}